export const getEnv = (): 'dev' | 'prod' | 'test' | 'e2e' => {
  // returns 'test' when mocked by jest (see jestMocks.ts)
  const isE2e = !!window.Cypress
  return isE2e ? 'e2e' : process.env.NODE_ENV === 'development' ? 'dev' : 'prod'
}
